import React, {useState} from "react";
import MenuItem from "@mui/material/MenuItem"
import {FormattedMessage} from "react-intl";
import ListingActionsSelect from "components/Product/Table/ListingActionsSelect";
import DeleteProductsActionModal from "domain/components/merchandising/batchActions/DeleteProductsActionModal";
import UpdateBrandActionModal from "domain/components/merchandising/batchActions/UpdateBrandActionModal";
import AddCornerActionModal from "domain/components/merchandising/batchActions/AddCornerActionModal";
import RemoveCornerActionModal from "domain/components/merchandising/batchActions/RemoveCornerActionModal";
import UpdateGenderActionModal from "domain/components/merchandising/batchActions/UpdateGenderActionModal";
import ActivateOfferActionModal from "domain/components/merchandising/batchActions/ActivateOfferActionModal";
import DeactivateOfferActionModal from "domain/components/merchandising/batchActions/DeactivateOfferActionModal";
import RemoveRankingActionModal from "domain/components/merchandising/batchActions/RemoveRankingActionModal";
import {MENU_KEY_TO_API_TYPE} from "domain/components/merchandising/batchActions/batchActionTypes";

export default function SelectBatchAction(props) {
    const [action, setAction] = useState('');
    const [openModal, setOpenModal] = useState(false);

    // a merchandising action type already running on the organization cannot
    // be launched again until it completes; the actions launched from a
    // retailer product list (retailerName set) do not block the merchandising
    const runningTypes = new Set(
        (props.runningActions ?? [])
            .filter((runningAction) => !runningAction.retailerName)
            .map((runningAction) => runningAction.actionType)
    );

    const components = {
        activate: ActivateOfferActionModal,
        deactivate: DeactivateOfferActionModal,
        removeRanking: RemoveRankingActionModal,
        updateGender: UpdateGenderActionModal,
        updateBrand: UpdateBrandActionModal,
        addCorner: AddCornerActionModal,
        removeCorner: RemoveCornerActionModal,
        deleteProducts: DeleteProductsActionModal,
    };

    const handleChange = (event) => {
        setAction(event.target.value);
        setOpenModal(true);
    };

    function displayModal() {
        if (action === '') {
            return;
        }

        const ModalComponent = components[action];
        return (
            <ModalComponent
                selectedProducts={props.selectedProducts}
                setSelectAction={setAction}
                setOpen={setOpenModal}
                open={openModal}
                selectAll={props.selectAll}
                totalItems={props.totalItems}
                buildBody={props.buildBody}
                onActionLaunched={props.onActionLaunched}
            />
        );
    }

    return (
        <>
            <ListingActionsSelect
                displayEmpty={true}
                autoWidth={true}
                disabled={props.isActionsDisabled}
                onChange={handleChange}
                value={action}
            >
                <MenuItem disabled value="">
                    <FormattedMessage id={"merchandising.show.label.actions.placeholder"}/>
                </MenuItem>
                {Object.keys(components).map(key =>
                    <MenuItem
                        key={key}
                        value={key}
                        disabled={runningTypes.has(MENU_KEY_TO_API_TYPE[key])}
                        className={key === 'deleteProducts' ? 'destructive' : undefined}
                    >
                        <FormattedMessage id={"merchandising.show.label.actions." + key}/>
                    </MenuItem>
                )}
            </ListingActionsSelect>
            {displayModal()}
        </>
    );
}
